export default {
  updateAll(state, value) {
    state.all = value
  }
}
